import { Breadcrumbs } from "@/components/ui/breadcrumbs";
import { H2 } from "@/components/ui/typography";
import { CityTable } from "@/features/city/CityTable";

export function CityIndex() {
  return (
    <>
      <Breadcrumbs
        list={[
          {
            label: "Master Data",
          },
          {
            href: "/master-data/city",
            label: "City (Kota/Kab)",
          },
        ]}
      />
      <H2>City (Kota/Kab) List</H2>
      <CityTable />
    </>
  );
}
